export const windowEvents = {
  RESET_CAMERA: "resetCamera",
  DISABLE_ORBIT: "disableOrbitControls",
  ENABLE_ORBIT: "enableOrbitControls",
  TOGGLE_ORBIT: "toggleOrbitControls",
  SENSORS_DELETE: "sensorsDelete",
};

export const subscribe = (eventName, action, element = document) => {
  element.addEventListener(eventName, action);
};

export const unsubscribe = (eventName, action, element = document) => {
  element.removeEventListener(eventName, action);
};

export const publish = (eventName, data, element = document) => {
  const event = new CustomEvent(eventName, { detail: data });
  element.dispatchEvent(event);
};
